import React, { Fragment } from "react";
import Header from "../components/Header";
import Sidebar from "../components/Sidebar";
import Footer from "../components/Footer";
import Loader from "../components/Loader";
import { Link } from "react-router-dom";
import { SITENAMEALIAS, ASSETS } from "../utils/init";
import {
  showToast,
  showHttpError,
  handleCurrencyDetiails,
  showConfirm,
  currentPageAccess,
} from "../utils/library";
import { getAllHostedCatalogs, DeleteHostedCatalog } from "../utils/service";
import PageHeader from "../components/PageHeader";

const styles = {
  pageWrapper: {
    padding: "36px 24px 60px",
  },
  headerRow: {
    display: "flex",
    justifyContent: "space-between",
    alignItems: "flex-start",
    marginBottom: "28px",
    flexWrap: "wrap",
    gap: "16px",
  },
  pageTitle: {
    fontSize: "24px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  pageSubtitle: {
    fontSize: "13px",
    opacity: 0.5,
    margin: "4px 0 0",
  },
  btnPrimary: {
    padding: "10px 24px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "pointer",
    display: "flex",
    alignItems: "center",
    gap: "6px",
    textDecoration: "none",
    letterSpacing: "0.3px",
  },
  btnPrimaryDisabled: {
    padding: "10px 24px",
    background: "var(--btn-color)",
    color: "#fff",
    border: "none",
    borderRadius: "10px",
    fontSize: "13px",
    fontWeight: "600",
    cursor: "not-allowed",
    opacity: 0.5,
    display: "flex",
    alignItems: "center",
    gap: "6px",
    textDecoration: "none",
    letterSpacing: "0.3px",
  },
  card: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
  },
  cardHeader: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    padding: "20px 28px",
    borderBottom: "1px solid var(--body-color-less2)",
  },
  cardHeaderIcon: {
    width: "36px",
    height: "36px",
    borderRadius: "10px",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    fontSize: "16px",
  },
  cardHeaderTitle: {
    fontSize: "16px",
    fontWeight: "700",
    color: "var(--text-color)",
    margin: 0,
  },
  cardBody: {
    padding: "24px 28px",
  },
  infoCard: {
    background: "var(--body-color-less)",
    borderRadius: "16px",
    border: "1px solid var(--body-color-less2)",
    boxShadow: "0 2px 12px rgba(0,0,0,0.06)",
    marginBottom: "24px",
    padding: "28px",
  },
  tipsList: {
    display: "flex",
    flexDirection: "column",
    gap: "14px",
  },
  tipItem: {
    display: "flex",
    alignItems: "center",
    gap: "12px",
    fontSize: "13px",
    lineHeight: "1.6",
    color: "var(--text-color)",
  },
  tipIcon: {
    color: "var(--btn-color)",
    fontSize: "14px",
    flexShrink: 0,
  },
  paymentMethods: {
    display: "flex",
    gap: "10px",
    flexWrap: "wrap",
    marginTop: "8px",
  },
  methodBadge: {
    padding: "6px 14px",
    borderRadius: "20px",
    fontSize: "12px",
    fontWeight: "600",
    background: "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 12%, transparent), color-mix(in srgb, var(--btn-color) 4%, transparent))",
    color: "var(--btn-color)",
    border: "1px solid color-mix(in srgb, var(--btn-color) 20%, transparent)",
  },
  th: {
    padding: "14px 16px",
    fontSize: "11px",
    fontWeight: "700",
    textTransform: "uppercase",
    letterSpacing: "0.5px",
    color: "var(--text-color)",
    opacity: 0.5,
    borderBottom: "1px solid var(--body-color-less2)",
    textAlign: "left",
    background: "transparent",
  },
  td: {
    padding: "14px 16px",
    fontSize: "14px",
    color: "var(--text-color)",
    borderBottom: "1px solid var(--body-color-less2)",
    verticalAlign: "middle",
  },
  editBtn: {
    padding: "6px 16px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    border: "1px solid var(--btn-color)",
    background: "transparent",
    color: "var(--btn-color)",
    cursor: "pointer",
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    marginRight: "8px",
  },
  deleteBtn: {
    padding: "6px 16px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    border: "none",
    background: "rgba(239,68,68,0.1)",
    color: "#ef4444",
    cursor: "pointer",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
  },
  deleteBtnDisabled: {
    padding: "6px 16px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    border: "none",
    background: "rgba(239,68,68,0.1)",
    color: "#ef4444",
    cursor: "not-allowed",
    opacity: 0.5,
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
  },
  editBtnDisabled: {
    padding: "6px 16px",
    borderRadius: "8px",
    fontSize: "12px",
    fontWeight: "600",
    border: "1px solid var(--btn-color)",
    background: "transparent",
    color: "var(--btn-color)",
    cursor: "not-allowed",
    opacity: 0.5,
    textDecoration: "none",
    display: "inline-flex",
    alignItems: "center",
    gap: "4px",
    marginRight: "8px",
  },
  priceChip: {
    fontFamily: "'SF Mono', 'Fira Code', monospace",
    fontSize: "13px",
    fontWeight: "600",
  },
  emptyState: {
    textAlign: "center",
    padding: "48px 24px",
  },
  emptyIcon: {
    width: "56px",
    height: "56px",
    borderRadius: "16px",
    background: "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 12%, transparent), color-mix(in srgb, var(--btn-color) 4%, transparent))",
    display: "flex",
    alignItems: "center",
    justifyContent: "center",
    margin: "0 auto 16px",
    fontSize: "24px",
    color: "var(--btn-color)",
  },
  emptyTitle: {
    fontSize: "15px",
    fontWeight: "600",
    color: "var(--text-color)",
    marginBottom: "6px",
  },
  emptySubtitle: {
    fontSize: "13px",
    color: "var(--text-color)",
    opacity: 0.5,
  },
};

class HostedCatalog extends React.Component {
  constructor(props) {
    super(props);
    this.state = {
      showLoader: false,
      isCheckedClickToPayUri: true,
      isCheckedScanToPayQr: true,
      isCheckedCopyPastePaymentMethod: true,
      pageNo: "1",
      noOfItemsPerPage: "50",
      hostedCatalogList: [],
      totalCount: "0",
    };
  }

  renderAllHostedCatelog = () => {
    this.setState({ showLoader: true });
    let payload = {
      merchant_id: parseInt(
        localStorage.getItem(SITENAMEALIAS + "_merchant_id")
      ),
      no_of_items_in_a_page: this.state.noOfItemsPerPage,
      page_no: this.state.pageNo,
    };
    getAllHostedCatalogs(payload)
      .then(
        function (res) {
          this.setState({ showLoader: false });
          let response = res.data;
          let errorObj = response[response.length - 1];
          if (errorObj.error != "0") {
            showToast("error", errorObj.error_msg);
          } else {
            let arr = [];
            for (let i = 0; i < response.length - 1; i++) {
              arr.push(response[i]);
            }
            console.log(arr);
            this.setState({
              hostedCatalogList: arr,
              totalCount: errorObj.totalCount,
            });
          }
        }.bind(this)
      )
      .catch(
        function (err) {
          this.setState({ showLoader: false });
          showHttpError(err);
        }.bind(this)
      );
  };

  handleDeleteHostedCatalog = (id) => {
    showConfirm("Delete", "Are you sure want to delete?", "warning", () => {
      this.setState({ showLoader: true });
      let payload = {
        merchant_id: parseInt(
          localStorage.getItem(SITENAMEALIAS + "_merchant_id")
        ),
        hosted_catalog_id: id,
      };
      DeleteHostedCatalog(payload)
        .then(
          function (res) {
            this.setState({ showLoader: false });
            let response = res.data;
            let errorObj = response[response.length - 1];
            if (errorObj.error != "0") {
              showToast("error", errorObj.error_msg);
            } else {
              this.renderAllHostedCatelog();
            }
          }.bind(this)
        )
        .catch(
          function (err) {
            this.setState({ showLoader: false });
            showHttpError(err);
          }.bind(this)
        );
    });
  };

  componentDidMount() {
    this.setState({
      permission: currentPageAccess(),
    });
    this.renderAllHostedCatelog();
  }

  renderEmptyState() {
    return (
      <div style={styles.emptyState}>
        <div style={styles.emptyIcon}>
          <i className="mdi mdi-shopping" />
        </div>
        <div style={styles.emptyTitle}>No catalog items yet</div>
        <div style={styles.emptySubtitle}>
          Add your first item to start accepting payments via Buy Now buttons
        </div>
      </div>
    );
  }

  render() {
    return (
      <Fragment>
        <div className="container-scroller">
          <Sidebar />
          <Header />
          <div className="main-panel">
            <div style={styles.pageWrapper}>
              {/* Header */}
              <div style={styles.headerRow}>
                <PageHeader icon="mdi-store" title="Checkout Pages" subtitle="Create Buy Now buttons and manage your product catalog" />
                {this.state.permission == "WRITE" ? (
                  <Link to="/hosted-catalog-item" style={styles.btnPrimary}>
                    <i className="mdi mdi-plus" /> Add New Item
                  </Link>
                ) : (
                  <button
                    style={styles.btnPrimaryDisabled}
                    onClick={() => {
                      showToast(
                        "error",
                        "You need write access to perform this operation"
                      );
                    }}
                    disabled
                  >
                    <i className="mdi mdi-plus" /> Add New Item
                  </button>
                )}
              </div>

              {/* Info Tips Card */}
              <div style={styles.infoCard}>
                <div style={{ display: "flex", alignItems: "center", gap: "12px", marginBottom: "18px" }}>
                  <div
                    style={{
                      ...styles.cardHeaderIcon,
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, var(--btn-color) 15%, transparent), color-mix(in srgb, var(--btn-color) 5%, transparent))",
                      color: "var(--btn-color)",
                    }}
                  >
                    <i className="mdi mdi-lightbulb-outline" />
                  </div>
                  <h4 style={{ ...styles.cardHeaderTitle, fontSize: "15px" }}>How It Works</h4>
                </div>
                <div style={styles.tipsList}>
                  <div style={styles.tipItem}>
                    <i className="fa fa-check-circle" style={styles.tipIcon} />
                    <span>
                      This utility can be used to quickly create Buy Now buttons
                      for the website.
                    </span>
                  </div>
                  <div style={styles.tipItem}>
                    <i className="fa fa-check-circle" style={styles.tipIcon} />
                    <span>
                      Blockchain handles the checkout process, and collects the
                      buyers name and address if necessary.
                    </span>
                  </div>
                  <div style={styles.tipItem}>
                    <i className="fa fa-check-circle" style={styles.tipIcon} />
                    <span>
                      When the transaction is completed, you will receive an
                      order confirmation via email, and the customer will be
                      directed back to your website.
                    </span>
                  </div>
                </div>

                <div style={{ marginTop: "20px" }}>
                  <div style={{ fontSize: "12px", fontWeight: "600", textTransform: "uppercase", letterSpacing: "0.3px", color: "var(--text-color)", opacity: 0.5, marginBottom: "10px" }}>
                    Supported Payment Methods
                  </div>
                  <div style={styles.paymentMethods}>
                    <span style={styles.methodBadge}>Click-to-pay URL</span>
                    <span style={styles.methodBadge}>Scan-to-pay QR Code</span>
                    <span style={styles.methodBadge}>Copy / Paste Payment</span>
                  </div>
                </div>
              </div>

              {/* Catalog Table Card */}
              <div style={styles.card}>
                <div style={styles.cardHeader}>
                  <div
                    style={{
                      ...styles.cardHeaderIcon,
                      background:
                        "linear-gradient(135deg, color-mix(in srgb, #8b5cf6 15%, transparent), color-mix(in srgb, #8b5cf6 5%, transparent))",
                      color: "#8b5cf6",
                    }}
                  >
                    <i className="mdi mdi-shopping" />
                  </div>
                  <h4 style={styles.cardHeaderTitle}>Catalog Items</h4>
                  <span
                    style={{
                      marginLeft: "auto",
                      fontSize: "12px",
                      fontWeight: "600",
                      color: "var(--text-color)",
                      opacity: 0.4,
                    }}
                  >
                    {this.state.hostedCatalogList.length} item
                    {this.state.hostedCatalogList.length !== 1 ? "s" : ""}
                  </span>
                </div>

                {this.state.hostedCatalogList.length === 0 ? (
                  this.renderEmptyState()
                ) : (
                  <div style={{ overflowX: "auto", overflowY: "hidden", WebkitOverflowScrolling: "touch" }}>
                    <table style={{ width: "100%", borderCollapse: "collapse", minWidth: "500px" }}>
                      <thead>
                        <tr>
                          <th style={styles.th}>Item</th>
                          <th style={styles.th}>Price</th>
                          <th style={{ ...styles.th, textAlign: "right" }}>
                            Actions
                          </th>
                        </tr>
                      </thead>
                      <tbody>
                        {this.state.hostedCatalogList.map((item) => (
                          <tr key={item.HOSTED_CATALOG_ID}>
                            <td style={styles.td}>
                              <span style={{ fontWeight: "500" }}>
                                {item.MERCHANT_NAME}
                              </span>
                            </td>
                            <td style={styles.td}>
                              <span style={styles.priceChip}>
                                {item.ITEM_PRICE}
                              </span>
                            </td>
                            <td
                              style={{
                                ...styles.td,
                                textAlign: "right",
                              }}
                            >
                              {this.state.permission == "WRITE" ? (
                                <Link
                                  to={
                                    "/edit-hosted-catalog-item/" +
                                    item.HOSTED_CATALOG_ID
                                  }
                                  style={styles.editBtn}
                                >
                                  <i className="mdi mdi-pencil-outline" /> Edit
                                </Link>
                              ) : (
                                <button
                                  style={styles.editBtnDisabled}
                                  onClick={() => {
                                    showToast(
                                      "error",
                                      "You need write access to perform this operation"
                                    );
                                  }}
                                  disabled
                                >
                                  <i className="mdi mdi-pencil-outline" /> Edit
                                </button>
                              )}
                              {this.state.permission == "WRITE" ? (
                                <button
                                  style={styles.deleteBtn}
                                  onClick={() => {
                                    this.handleDeleteHostedCatalog(
                                      item.HOSTED_CATALOG_ID
                                    );
                                  }}
                                >
                                  <i className="mdi mdi-delete-outline" /> Delete
                                </button>
                              ) : (
                                <button
                                  style={styles.deleteBtnDisabled}
                                  onClick={() => {
                                    showToast(
                                      "error",
                                      "You need write access to perform this operation"
                                    );
                                  }}
                                  disabled
                                >
                                  <i className="mdi mdi-delete-outline" /> Delete
                                </button>
                              )}
                            </td>
                          </tr>
                        ))}
                      </tbody>
                    </table>
                  </div>
                )}
              </div>
            </div>
            <Footer />
          </div>
          <Loader show={this.state.showLoader} />
        </div>
      </Fragment>
    );
  }
}

export default HostedCatalog;
